export default __webpack_public_path__ + "static/media/no_data@2x.0254803e.png";